
import { useState } from 'react';
import Hero from './components/Hero';
import LatestEpisodes from './components/LatestEpisodes';
import Shorts from './components/Shorts';
import About from './components/About';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <LatestEpisodes />
      <Shorts />
      <About />
      <Newsletter />
      <Footer />
    </div>
  );
}
